/**
 * BuckChat wrapper - uses @landtrustinc/buck-chat package.
 * Injects config from env vars and GTM analytics.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BuckChat as BuckChatPackage } from '@landtrustinc/buck-chat';
import useIsMobile from '../../hooks/use-is-mobile';
import { refreshAuthState } from '../../ducks/Auth.duck';
import { addFavoritePackageById } from '../../ducks/user.duck';
import { hasPremiumMembership } from '../../util/user';
import getBuckChatConfig from './config';
import useBuckChatHandlers from './hooks/useBuckChatHandlers';

const BuckChatComponent = props => {
  const { isMobile } = useIsMobile();
  const {
    onRefreshAuthState,
    onAddFavoritePackage,
    listingId,
    packageId,
    currentUser,
    ...rest
  } = props;

  const normalizedCurrentUser = currentUser
    ? {
        id: currentUser.id?.uuid ? { uuid: currentUser.id.uuid } : undefined,
        isAuthenticated: true,
        hasPremiumMembership: hasPremiumMembership(currentUser),
      }
    : undefined;

  const {
    handleAnalyticsEvent,
    handleAuthSuccess,
    handleLtPlusSuccess,
    handleFetchPackage,
  } = useBuckChatHandlers({ onRefreshAuthState, onAddFavoritePackage, listingId, packageId });

  return (
    <BuckChatPackage
      config={getBuckChatConfig(currentUser)}
      inlineEntryIsMobile={isMobile}
      listingId={listingId}
      packageId={packageId}
      currentUser={normalizedCurrentUser}
      onAnalyticsEvent={handleAnalyticsEvent}
      onAuthSuccess={handleAuthSuccess}
      onLtPlusSuccess={handleLtPlusSuccess}
      onFetchPackage={handleFetchPackage}
      {...rest}
    />
  );
};

BuckChatComponent.propTypes = {
  listingId: PropTypes.string.isRequired,
  packageId: PropTypes.string,
  currentUser: PropTypes.object,
  onRefreshAuthState: PropTypes.func.isRequired,
  onAddFavoritePackage: PropTypes.func.isRequired,
};

BuckChatComponent.defaultProps = {
  packageId: undefined,
  currentUser: undefined,
};

const mapDispatchToProps = dispatch => ({
  onRefreshAuthState: () => dispatch(refreshAuthState()),
  onAddFavoritePackage: (listingId, packageId) =>
    dispatch(addFavoritePackageById(listingId, packageId)),
});

const BuckChat = connect(
  null,
  mapDispatchToProps
)(BuckChatComponent);

export default BuckChat;
